// extracted by mini-css-extract-plugin
export default {"filterGroup":"ReportPerCallAverage_filterGroup__LE944","label":"ReportPerCallAverage_label__ToJva","title":"ReportPerCallAverage_title__c3QMq"};